import { RegexMatch } from "@/data/enums/router";

function guardFromComplete(to, from, next) {
  if (from.name === "adminOrderComplete")
    return next({
      name: "adminOrderShop",
      params: { basketId: RegexMatch.NEW }
    });
  next();
}

export default [
  {
    path: "baskets",
    components: {
      default: {
        name: "AdminBaskets",
        template: `<router-view />`
      }
    },
    meta: {
      breadcrumb: {
        label: "_.baskets"
      }
    },
    children: [
      {
        path: "",
        name: "adminBaskets",
        component: () => import("@/views/admin/baskets/index.vue"),
        meta: {
          auth: ["staff_list_orders"],
          title: "_.baskets",
          backTo: "_.baskets"
        }
      },
      {
        path: `:basketId(${RegexMatch.UUID}|${RegexMatch.NEW})`,
        name: "adminOrderBasket",
        meta: {
          auth: ["staff_get_order"],
          title: "_.basket",
          backTo: "_.basket"
        },
        props: {
          basketRoutes: require("./menu").default
        },
        component: () =>
          import("@/components/app/global/baskets/basket/index.vue"),
        children: [
          {
            path: "shop",
            name: "adminOrderShop",
            component: () =>
              import("@/components/app/global/baskets/basket/shop/index.vue"),
            meta: {
              title: "_.shop"
            }
          },
          {
            path: "product",
            name: "adminOrderProductView",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/productView/index.vue"
              ),
            meta: {
              title: "_.product"
            },
            beforeEnter: guardFromComplete
          },
          {
            path: "basket",
            name: "adminOrderBasketView",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/basketView/index.vue"
              ),
            meta: {
              title: "_.basket"
            },
            beforeEnter: guardFromComplete
          },
          {
            path: "checkout",
            name: "adminOrderCheckout",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/checkout/index.vue"
              ),
            meta: {
              title: "_.checkout"
            },
            beforeEnter: guardFromComplete
          },
          {
            path: "complete",
            name: "adminOrderComplete",
            component: () =>
              import(
                "@/components/app/global/baskets/basket/complete/index.vue"
              ),
            meta: {
              title: "_.complete"
            }
          }
        ]
      },
      {
        path: "403",
        component: () => import("@/views/error/index.vue"),
        meta: { error: 403 }
      },
      {
        path: "*",
        component: () => import("@/views/error/index.vue"),
        meta: { error: 404 }
      }
    ]
  }
];
